<template>
  <div>
    <CustomHead :head="head" />
    <PageHeader>
      <div 
        class="render-content mks-section-container page-events__header" 
        v-if="heroContent"
      >
        <CustomRenderContent :content="heroContent" model="a-la-une" />
        <!--RenderContent 
          model="a-la-une" 
          :api-key="$env.builder.apiKey" 
          :customComponents="getCustomComponents"
          :content="heroContent"
          :can-track="false"
        /-->
      </div>
    </PageHeader>
    <div class="page-events__content mks-section-container" ref="list-events">
      <Heading
        tag="h1" 
        tagClass="h2"
        textBefore="Tous les événements de "
        textBean="chiche"
        colorBean="roman"
      />
      <!-- <FilterEvents showQuickSearch source="homepage" list-type="agenda" layout="simple"></FilterEvents> -->
      <FilterEvents 
        showQuickSearch 
        source="homepage" 
        list-type="grid"
        layout="simple"
      >
      </FilterEvents>
    </div>
    <NewsletterHero source="chiche-event-list"/>
  </div>
</template>

<script>
import { isPreviewing } from '@builder_sdk';
import { REGISTERED_COMPONENTS } from '@/init-builder.ts';
import { useAsyncData } from 'nuxt/app';
import { useRoute } from 'vue-router';
import chicheMetas from '@/mixins/chicheMetas';
import CustomRenderContent from "~/components/organisms/RenderContent/CustomRenderContent.vue";


export default defineNuxtComponent({
  name: "PageEvents",
  components: {
    CustomRenderContent
  },
  mixins: [chicheMetas],
  data() {
    return {
      events: null
    }
  },
  computed: {
    head() {
      if (!this.content) return;
      if (this.events) {
        const schemaEvents = this.events.map(e => {
          return {
            type: 'event',
            data: e
          }
        })
        return this.getHead(this.content.data, [...schemaEvents, { type: 'search'}]);
      }
      else return this.getHead(this.content.data, [{ type: 'search'}]);
    },
    getCustomComponents() {
      return REGISTERED_COMPONENTS;
    },
  },
  async setup() {
    const nuxtApp = useNuxtApp();
    const route = useRoute();
    const previewing = route.query.previewing;

    if (nuxtApp.$env.SITE === 'international') {
      await navigateTo('/')
    }

    try {
      const { data: heroContent } = await useAsyncData(() => nuxtApp.$builder.getOne('a-la-une', {
        userAttributes: {
          urlPath: route.path,
        },
        includeUnpublished: previewing === 'true'
      }));
      const canShowHero = !!heroContent.value || isPreviewing() || previewing;

      const { data: content } = await useAsyncData(() => nuxtApp.$builder.getOne('page', {
        userAttributes: {
          urlPath: route.path,
        },
        includeUnpublished: previewing === 'true'
      }));
      const canShowContent = !!content.value || isPreviewing() || previewing;


      return { 
        heroContent: heroContent.value,
        canShowHero,
        content: content.value,
        canShowContent,
      };
    }
    catch (err) {
      console.log(err)
    }
    
  },
  methods: {
    onEventsLoaded(events) {
      this.events = events;
    }
  },
  mounted() {
    if (process.server || !window) return;
    if (this.$route.query.scroll === true || this.$route.query.scroll === 'true') {
      this.$nextTick(() => {
        const yOffset = -130; 
        const element = this.$refs["list-events"];
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
      });
    }
  }
});
</script>

<style lang="scss" scoped>
$hero-offset-mobile: 100px;
$hero-offset: 200px;
.page-events__header {
  text-align: center;
  padding-top: $space-m;
  margin-bottom: $hero-offset-mobile * -1;
  @include breakpoint('small') {
    margin-bottom: $hero-offset * -1;
  }
}

.page-events__content {
  margin-top: calc($space-xl + ($hero-offset-mobile / 2));

  @include breakpoint('small') {
    margin-top: calc($space-xl + $hero-offset);
  }
}

.page-events__spotlight {
  margin-top: $space-xl;
}


</style>
